module.exports = __webpack_public_path__ + "img/80400.99bc8b14.jpg";